import { c as _c } from "react/compiler-runtime";
import styles from './styles.module.scss';
interface SquareButtonProps extends React.ComponentPropsWithRef<'button'> {
  size?: '32' | '24';
  children: React.ReactNode;
}
export default function SquareButton(t0) {
  const $ = _c(8);
  let children;
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      children,
      size: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = props;
    $[3] = t1;
  } else {
    children = $[1];
    props = $[2];
    t1 = $[3];
  }
  const size = t1 === undefined ? "32" : t1;
  let t2;
  if ($[4] !== children || $[5] !== props || $[6] !== size) {
    t2 = <button className={styles.squareButton} data-size={size} {...props}>{children}</button>;
    $[4] = children;
    $[5] = props;
    $[6] = size;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
}